function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.07606 23.9056C-2.02068 19.1795 -2.02068 4.82037 8.07606 0.0942383L8.92394 1.90562C0.363358 5.9127 0.363358 18.0872 8.92394 22.0942L8.07606 23.9056Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 3.25012,
  y1: -18.2501,
  x2: 3.25012,
  y2: 33.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D76969"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.248451,
  stopColor: "#D79C69"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#E9B880"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.766226,
  stopColor: "#D2D65A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#60AB8B"
})));

var SvgCurvedLine = function SvgCurvedLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 24,
    viewBox: "0 0 9 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCurvedLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/curved-line.b7048604.svg";
export { ForwardRef as ReactComponent };